export const USER_ROLES = ['teacher', 'barista', 'admin'];
export const FULFILLMENT_METHODS = [
    'pickup',
    'delivery',
];
export const FULFILLMENT_METHOD_LABELS = {
    pickup: 'Pickup at counter',
    delivery: 'Delivery to room',
};
export const ORDER_STATUSES = [
    'pending',
    'accepted',
    'preparing',
    'ready',
    'completed',
    'cancelled',
];
export const PAYMENT_STATUSES = [
    'unpaid',
    'paid',
    'refunded',
];
export const CUSTOMIZATION_GROUP_TYPES = [
    'single',
    'multi',
];
/**
 * Status transitions the barista UI is allowed to trigger.
 *
 * The kitchen is a single-tap workflow: a barista taps "Done" to finish an
 * order and "Cancel" to drop it, from whatever state it's in. So every
 * active status may move *forward* to any later status (including straight
 * to `completed`) or to `cancelled`. Backward moves stay disallowed — only
 * admins can rewind an order, via the admin order log. Admins bypass this
 * map entirely.
 */
export const BARISTA_ALLOWED_TRANSITIONS = {
    pending: ['accepted', 'preparing', 'ready', 'completed', 'cancelled'],
    accepted: ['preparing', 'ready', 'completed', 'cancelled'],
    preparing: ['ready', 'completed', 'cancelled'],
    ready: ['completed', 'cancelled'],
    completed: [],
    cancelled: [],
};
export const ORDER_STATUS_LABELS = {
    pending: 'Pending',
    accepted: 'Accepted',
    preparing: 'Preparing',
    ready: 'Ready for Pickup',
    completed: 'Completed',
    cancelled: 'Cancelled',
};
export const PAYMENT_STATUS_LABELS = {
    unpaid: 'Unpaid',
    paid: 'Paid',
    refunded: 'Refunded',
};
export const USER_ROLE_LABELS = {
    teacher: 'Teacher',
    barista: 'Barista',
    admin: 'Admin',
};
/** Maximum orders one teacher may place per rolling hour. Enforced server-side. */
export const RATE_LIMIT_ORDERS_PER_HOUR = 10;
/** Default tax rate used when shop settings have not yet been written. 7.25% (NC). */
export const DEFAULT_TAX_RATE = 0.0725;
/** Default estimated prep time in minutes. */
export const DEFAULT_ESTIMATED_PREP_MINUTES = 5;
/** Singleton document ID for shop settings inside the /settings collection. */
export const SHOP_SETTINGS_DOC_ID = 'shop';
/** Firestore collection names. Single source of truth. */
export const COLLECTIONS = {
    users: 'users',
    menuCategories: 'menuCategories',
    menuItems: 'menuItems',
    orders: 'orders',
    settings: 'settings',
    /** Monotonic counters (currently just orderNumber). */
    counters: 'counters',
};
/** Document ID in /counters for the sequential order-number sequence. */
export const ORDER_NUMBER_COUNTER_DOC_ID = 'orderNumber';
/** Local storage keys used by the web app. */
export const LS_KEYS = {
    cart: 'cracked-mug:cart',
    authToken: 'cracked-mug:auth-token',
};
/** Default tip presets surfaced at checkout. Percentages are decimals (0.15 = 15%). */
export const TIP_PRESETS = {
    zeroDollar: { kind: 'flat', cents: 0 },
    oneDollar: { kind: 'flat', cents: 100 },
    twoDollar: { kind: 'flat', cents: 200 },
    fifteenPct: { kind: 'percent', value: 0.15 },
    twentyPct: { kind: 'percent', value: 0.2 },
};
//# sourceMappingURL=constants.js.map